export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.207 4.207l-2.018 2.017A6.501 6.501 0 0117.5 19H6.414L3.5 21.914 2.086 20.5l1.658-1.66A5.002 5.002 0 015 9h.023A5.5 5.5 0 0110.5 4a5.493 5.493 0 014.956 3.129l4.337-4.336 1.414 1.414zM8.414 17H17.5a4.5 4.5 0 100-9h-.086l-9 9zM10.5 6a3.5 3.5 0 00-3.464 3.998 1 1 0 01-1.25 1.107A3 3 0 105 17h.585l8.368-8.37-.196-.414A3.5 3.5 0 0010.5 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};